import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDevices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('devices', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getOwners(ctx) {
      return new Promise((resolve, reject) => {
        axios.get(`getOwners`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getDevicesFilters(ctx) {
      return new Promise((resolve, reject) => {
        axios.get(`getDevicesFilters`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`devices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDevice(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.post('devices', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editDevice(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`devices/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteDevice(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`devices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    importFile(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.post(`devicesImportExcel`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }

  },
}
